import { CardsData } from '@src/components/sco/SocialProofCardsData/cardsData'
import cardsData from '@src/data/social-proof.json'

// Function to process and sort cards data
export const processCardsData = (idsToRender: string[]) => {
  const typedCardsData: CardsData = cardsData.reduce((acc, curr) => {
    const key = Object.keys(curr)[0] // Get the key of the current item (e.g., 'statsCards')
    acc[key] = curr[key] // Assign the array to the correct key in the accumulator
    return acc
  }, {} as CardsData)

  const allCards = Object.values(typedCardsData).flat()

  const filteredCards = allCards.filter(card => idsToRender.includes(card.id))

  const sortedCards = filteredCards.sort((a, b) => {
    return idsToRender.indexOf(a.id) - idsToRender.indexOf(b.id)
  })

  return sortedCards
}
